module.exports = __webpack_public_path__ + "static/media/power-hp1.7b57295e.png";